export default __webpack_public_path__ + "static/media/15-inactive.8ca68a2d.svg";